import Enum from "./Enum";

export default Enum.create( {
	ACTIVE: "ACTIVE",
	DRAFT: "DRAFT",
	ARCHIVED: "ARCHIVED",
} );
